export default function findParentByClass(el, classToCheck) {
  if (el.classList.contains(classToCheck)) {
    return el;
  }
  return el.parentElement && findParentByClass(el.parentElement, classToCheck);
}
